<div class="input-group">
  <input
    #search
    (input)="onSearchUpdated(search.value)"
    class="form-control"
    type="text"
    [placeholder]="placeholder"
  />
  <span class="input-group-text" id="basic-addon2">
    @if(search.value) {
      <i class="bi bi-x-lg" (click)="clearSearch(search)"></i>
    } @else {
      <i class="bi bi-search"></i>
    }
  </span>
</div>
